<div class="modal-body" id="modal-body">
  <app-users-list (rowClick)="modal.close($event)">
  </app-users-list>
</div>